import React, { useState, memo, useContext } from "react";
import { DropdownMenu, ToolWrapper } from "../styled/PanelTools.styled";
import { LightTooltip } from "../styled/LightTooltip.styled";
import { ToolIcons } from "../../constants/WebMap";
import { getUserUploadedFiles } from "../../services/api/users.api";
import { WebMapContext } from "../../pages/sections/web-map/WebMapGoogleMap";
import { toast } from "react-toastify";

const PanelSingleTool = ({
  toolTitle,
  toolTip,
  toolPos,
  toolImg,
  toolWidth,
  toolHeight,
  toolSelected,
  isDropDown,
  isDropDownOpen,
  isSvg,
  handleClick,
  onClickDropdown,
  options = [],
  action,
}) => {
  const {
    setIsLoading,
  } = useContext(WebMapContext);

  const toggleDropdown = () => {
    onClickDropdown(action);
  };

  const handleOptionClick = (option) => {
    handleClick(option);
  };

  const fetchUploadedFiles = async () => {
    try {
      setIsLoading(true);
      const updatedFiles = await getUserUploadedFiles();

      if (updatedFiles.length < 5) {
        toggleDropdown();
      } else {
        throw new Error("COUNT_EXCEEDED");
      }
    } catch (error) {
      if (error?.message === "COUNT_EXCEEDED") {
        toast.error(
          "The upload limit is 5 files. Please remove one file to add a new one.",
          {
            theme: "colored",
          }
        );
        return;
      }
      toast.error("Something went wrong!", {
        theme: "colored",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const dropdownAction = async () => {
    if(toolTitle === "Upload Files") {
      fetchUploadedFiles();
    } else if (toolTitle === "Download Files"){
      toggleDropdown();
    }
  };

  const SvgImage = ToolIcons[toolImg];

  return (
    <div style={{ position: "relative" }}>
      <LightTooltip title={toolTip} placement={toolPos || "bottom"}>
        <ToolWrapper
          onClick={() => (isDropDown ? dropdownAction() : handleClick(action))}
          isSelected={toolSelected}
          backgroundColor={isDropDownOpen ? "#007842" : "#f0f0f0"}
          data-testid="ToolWrapper-test"
        >
          {/* SVG Icon */}
          {isSvg ? (
            <SvgImage  bgColor={isDropDownOpen? "#007842" : "#f0f0f0"} strokeColor={isDropDownOpen? "#FFF" : "#707070"} style={{ width: '30px', height: toolHeight }}/>
          ) : (
            <img
              src={toolImg}
              width={toolWidth || "24px"}
              height={toolHeight || "24px"}
            />
          )}
        </ToolWrapper>
      </LightTooltip>
      {isDropDownOpen && (
        <DropdownMenu>
          {options?.map((option, index) => (
            <div
              key={index}
              onClick={() => handleOptionClick(option?.key)}
              data-testid={`dropdown-option-${index}`}
              style={{
                padding: "8px 12px",
                cursor: "pointer",
                hover: { background: "#f7f7f7" },
              }}
            >
              {option?.name}
            </div>
          ))}
        </DropdownMenu>
      )}
    </div>
  );
};

export default memo(PanelSingleTool);
